import React, { useEffect, useState, useContext, createContext } from 'react';
import { Select } from 'antd';
import http, {InverterContext} from '../../Http';
import utils from '../../utils';
import RealtimeMonitor from './RealtimeMonitor';
import RealtimeMonitorUhomeSinglePhase from './RealtimeMonitorUhomeSinglePhase';
import DataAnalysis from './DataAnalysis/DataAnalysis';
import SiteManagement from './SiteManagement';
import Outline from './Outline';
import RemoteSetting from './RemoteSetting/RemoteSetting';
import Configuration from './Configuration/Configuration.js';
import './RealtimeMonitor.css';
import './DataAnalysis/DataAnalysis.css';
import './Outline.css';
import './RemoteSetting/RemoteSetting.css';
import AdvancedSetting from './AdvancedSetting/AdvancedSetting';
import RealtimeMonitorUhomeThreePhase from './RealtimeMonitorUhomeThreePhase/RealtimeMonitorUhomeThreePhase';

function Inverter2(props) {
    const { activeMenu } = props;

    const setTip = useContext(utils.tipContext)

    const [inverterSelectOptions, setInverterSelectOptions] = useState([])  //所有电站列表
    const [SN, setSN] = useState(null)  //当前选择的逆变器SN
    const [ID, setID] = useState("")
    const [Timezone, setTimezone] = useState("")
    const [protocols, setProtocols] = useState([])  //所有逆变器的protocol
    const [protocol, setProtocol] = useState(null)  //当前逆变器的protocol
    const [invModel, setInvModel] = useState(null)
    const [isBalcony, setIsBalcony] = useState(false)
    const [refresh, setRefresh] = useState(false)  //刷新逆变器列表

    //获取电站列表
    useEffect(() => {
        let active = true;

        (async () => {
            let resp = await http.post("integrated-inverter/list", {
                PageNo: 0,
                PageSize: 10000,
            }).then(async (r) => {
                return await r.json();
            }).catch((e) => {
                return null;
            });

            if (!active) {
                return;
            }
            if (resp === null || resp.code !== 200) {
                setTip({ open: true, severity: "error", msg: (resp && resp.msg) ? resp.msg : "load inverter list error" });
                return;
            }

            //逆变器选择框
            const ps = {}
            const ls = resp.data.map((v, index) => {
                ps[v.SerialName] = v.Protocol
                ps[v.SerialName + "_Model"] = v.Model;
                ps[v.SerialName + '_isBalcony'] = false
                return <Select.Option key={index} data-timezone={v.Timezone} data-id={v.ID} value={v.SerialName}>{v.SerialName}</Select.Option>
            })

            setInverterSelectOptions(ls)
            setProtocols(ps)
        })();

        return () => {
            active = false;
        };

    }, [refresh]);

    const handleSelectSN = (sn, option) => {
        setSN(sn)
        setProtocol(protocols[sn])
        setInvModel(protocols[sn + "_Model"])
        setIsBalcony(protocols[sn + "_isBalcony"])
        setTimezone(option["data-timezone"])
        setID(option["data-id"])
    }

    const handleRefreshInverter = () => {
        setRefresh(!refresh)
    }

    return (
        <>
            <InverterContext.Provider value={handleRefreshInverter}>
            {
                activeMenu == 0 ? 
                (protocol === 'Uhome-SinglePhase' ? <RealtimeMonitorUhomeSinglePhase Timezone={Timezone} inverterSelectOptions={inverterSelectOptions} SN={SN} protocol={protocol} model={invModel} isBalcony={isBalcony} handleSelectSN={handleSelectSN} {...props} /> 
                    : protocol === 'Uhome-ThreePhase' ? <RealtimeMonitorUhomeThreePhase Timezone={Timezone} ID={ID} inverterSelectOptions={inverterSelectOptions} SN={SN} protocol={protocol} model={invModel} isBalcony={isBalcony} handleSelectSN={handleSelectSN} {...props} />
                    : <RealtimeMonitor Timezone={Timezone} ID={ID} inverterSelectOptions={inverterSelectOptions} SN={SN} protocol={protocol} model={invModel} isBalcony={isBalcony} handleSelectSN={handleSelectSN} {...props} />
                ) :
                activeMenu == 1 ? <DataAnalysis Timezone={Timezone} inverterSelectOptions={inverterSelectOptions} SN={SN} protocol={protocol} model={invModel} handleSelectSN={handleSelectSN} /> :
                activeMenu == 2 ? <SiteManagement inverterSelectOptions={inverterSelectOptions} SN={SN} protocol={protocol} handleSelectSN={handleSelectSN} /> :
                activeMenu == 3 ? <Outline inverterSelectOptions={inverterSelectOptions} SN={SN} model={invModel} protocol={protocol} handleSelectSN={handleSelectSN} /> :
                activeMenu == 4 ? <RemoteSetting inverterSelectOptions={inverterSelectOptions} SN={SN} protocol={protocol} handleSelectSN={handleSelectSN} /> :
                activeMenu == 5 ? <Configuration inverterSelectOptions={inverterSelectOptions} SN={SN} protocol={protocol} handleSelectSN={handleSelectSN} /> :
                activeMenu == 6 ? <AdvancedSetting /> :
                    null
            }
            </InverterContext.Provider>
        </>
    )
}

export default Inverter2;